export const OperatorType = {
  OWNER: 1,
  MANAGER: 2,
  EMPLOYEE: 3,
  VIEWER: 4,
};

export const ASSIGNABLE_OPERATOR_TYPES = [
  { id: OperatorType.MANAGER, label: 'Менеджер' },
  { id: OperatorType.EMPLOYEE, label: 'Сотрудник' },
  { id: OperatorType.VIEWER, label: 'Наблюдатель' },
];

export function operatorTypeLabel(typeId) {
  const id = Number(typeId);
  const match = ASSIGNABLE_OPERATOR_TYPES.find((item) => item.id === id);
  if (match) return match.label;
  if (id === OperatorType.OWNER) return 'Владелец';
  return 'Сотрудник';
}

export function canManageEmployees(typeId) {
  const id = Number(typeId);
  return id === OperatorType.OWNER || id === OperatorType.MANAGER;
}

function isSameOperator(employee, operatorId) {
  return operatorId != null && String(employee?.id) === String(operatorId);
}

export function canEditEmployee(employee, operatorId, operatorTypeId) {
  const targetType = Number(employee?.typeId);
  if (operatorTypeId === OperatorType.OWNER) return true;
  if (operatorTypeId !== OperatorType.MANAGER) return false;
  if (targetType === OperatorType.OWNER) return false;
  if (targetType === OperatorType.MANAGER) return isSameOperator(employee, operatorId);
  return targetType === OperatorType.EMPLOYEE || targetType === OperatorType.VIEWER;
}

export function canDeleteEmployee(employee, operatorId, operatorTypeId) {
  if (isSameOperator(employee, operatorId)) return false;
  const targetType = Number(employee?.typeId);
  if (targetType === OperatorType.OWNER) return false;
  if (operatorTypeId === OperatorType.OWNER) return true;
  if (operatorTypeId !== OperatorType.MANAGER) return false;
  return targetType === OperatorType.EMPLOYEE || targetType === OperatorType.VIEWER;
}

export function employeeTypeOptions(operatorTypeId) {
  if (operatorTypeId === OperatorType.MANAGER) {
    return ASSIGNABLE_OPERATOR_TYPES.filter((type) => type.id !== OperatorType.MANAGER);
  }
  return ASSIGNABLE_OPERATOR_TYPES;
}

function readTokenPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4 === 0 ? '' : '='.repeat(4 - (base64.length % 4));
    return JSON.parse(atob(`${base64}${pad}`));
  } catch (_) {
    return null;
  }
}

export function readOperatorTypeId(token) {
  const typeId = Number(readTokenPayload(token)?.typeId);
  return Number.isFinite(typeId) ? typeId : null;
}

export function readOperatorId(token) {
  const id = Number(readTokenPayload(token)?.id);
  return Number.isFinite(id) ? id : null;
}

export function normalizeEmployeeUsername(value) {
  const username = String(value || '').trim().toLowerCase();
  if (username.length < 3 || username.length > 64) return null;
  const simple = /^[a-z0-9](?:[a-z0-9._-]*[a-z0-9])?$/;
  const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (simple.test(username) || email.test(username)) return username;
  return null;
}
